module.exports = __webpack_public_path__ + "static/img/积分兑换.23eef866.png";